import React from 'react';
import cn from 'clsx';
import PropTypes from 'prop-types';

import styles from './canonical-form-option.scss';

function CanonicalFormOption(props) {
  const {
    className,
    isFocused,
    isSelected,
    label,
    shouldResetFilter,
    suffix = ''
  } = props;
  let styleName = styles['option'];
  let message = '';

  if (isSelected) {
    styleName += ` ${styles['option--selected']}`;
  } else if (isFocused) {
    styleName += ` ${styles['option--focused']}`;
  }

  if (shouldResetFilter) {
    message = 'Selecting this may change other specs';
  }

  return (
    <div className={cn(styleName, className || 'react-select__option')}>
      {label}
      {suffix}
      {message && <span className={styles['message']}>{message}</span>}
    </div>
  );
}

CanonicalFormOption.propTypes = {
  className: PropTypes.string,
  isFocused: PropTypes.bool,
  isSelected: PropTypes.bool,
  label: PropTypes.string,
  shouldResetFilter: PropTypes.bool,
  suffix: PropTypes.string
};

export default CanonicalFormOption;
